import { devtools, persist } from 'zustand/middleware';
import { shallow } from 'zustand/shallow';
import { createWithEqualityFn } from 'zustand/traditional';

export type SearchSettingKey =
  | 'isDistributorsModeOn'
  | 'isPaymentTypesModeOn'
  | 'isExpiryModeOn'
  | 'isCostOfDeferredPaymentModeOn'
  | 'isWithoutOffersOn'
  | 'isSpecialPriceModeOn';
export type SearchSettingsConfig = Record<SearchSettingKey, boolean>;

type SearchSettingsConfigStore = {
  searchSettingsConfig: SearchSettingsConfig;

  actions: {
    setSearchSettingsConfig: (searchSettingsConfig: SearchSettingsConfig) => void;
  };
};

export const useSearchSettingsConfigStore = createWithEqualityFn<SearchSettingsConfigStore>()(
  devtools(
    persist(
      set => ({
        searchSettingsConfig: {
          isDistributorsModeOn: false,
          isPaymentTypesModeOn: false,
          isExpiryModeOn: false,
          isCostOfDeferredPaymentModeOn: false,
          isWithoutOffersOn: false,
          isSpecialPriceModeOn: false,
        },

        actions: {
          setSearchSettingsConfig: searchSettingsConfig =>
            set({ searchSettingsConfig }, false, 'setSearchSettingsConfig'),
        },
      }),
      {
        name: 'dorim-price:search-settings-config',
        partialize: state => ({
          searchSettingsConfig: state.searchSettingsConfig,
        }),
      },
    ),
    {
      name: 'search-settings-config-store',
      enabled: import.meta.env.DEV,
    },
  ),
);

export const selectSearchSettingsConfig = (state: SearchSettingsConfigStore) => state.searchSettingsConfig;

export const useSelectSearchSettingsConfig = () => useSearchSettingsConfigStore(selectSearchSettingsConfig, shallow);

export const useSearchSettingsStoreActions = () =>
  useSearchSettingsConfigStore((state: SearchSettingsConfigStore) => state.actions, shallow);
